const f = (i, e) => (t) => (
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  (typeof i == "function" ? i(t) : t[i]) ? e : void 0
);
export {
  f as modifier
};
